import "./index.css"

export default function Collapse({ isOpen, children, isShow }) {
  const expanded = isOpen || !isShow
  const className = isShow
    ? "px-4"
    : // Sidebar thu gọn: submenu nằm flyout bên phải.
      // Nếu user click mở (`isOpen=true`) thì bỏ `hidden` để có thể click chọn item luôn.
      `absolute left-full top-0 z-50 ml-0 min-w-[200px] bg-slate-900 shadow-lg rounded border border-white/10 ${
        // Với sidebar thu gọn ta điều khiển hiển thị bằng state `isOpen`
        // để click/hover đều có thể hoạt động ổn định.
        isOpen ? "" : "hidden"
      }`

  if (!expanded) {
    return null
  }

  return (
    <div className={`collapse ${className}`}>
      {children}
    </div>
  )
}
